var map = {
	"./flavor1.png": "6cc8",
	"./flavor10.png": "bc55",
	"./flavor2.png": "c696",
	"./flavor3.png": "6e2d",
	"./flavor4.png": "8dab",
	"./flavor5.png": "2cba",
	"./flavor6.png": "99d2",
	"./flavor7.png": "21f5",
	"./flavor8.png": "f4bd",
	"./flavor9.png": "12a5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9f7b";